import GenericMarkdown from './GenericMarkdown';

export default GenericMarkdown;
